<!--
Author: TangChen
Date: 2018-09-19
Desc:
-->
<template>
    <div class="comp-open-acct-crs-info comp">
        <el-row class="taxes-box two-cols-form">
            <el-form
                ref="taxesInfo"
                :model="taxesInfo"
                :rules="rules"
                label-width="85px"
                class="acct-form"
                size="small"
                inline-message
                v-on:submit.native.prevent
            >
                <el-col :span="24" class="mes-col">
                    <el-col :span="12">
                        <el-form-item
                            label="姓（英文或拼音）:"
                            prop="custfirstname"
                            class="required lh22"
                        >
                            <el-input
                                v-model="taxesInfo.custfirstname"
                                placeholder="请输入姓（英文或拼音）"
                                :maxlength="32"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="名（英文或拼音）:"
                            prop="custfamilyname"
                            class="required lh22"
                        >
                            <el-input
                                v-model="taxesInfo.custfamilyname"
                                placeholder="请输入名（英文或拼音）"
                                :maxlength="32"
                            />
                        </el-form-item>
                    </el-col>
                </el-col>
                <el-col :span="24" class="mes-col">
                    <el-col :span="24">
                        <div class="line-container">
                            <div class="lines"></div>
                            <span class="content">现居地</span>
                            <div class="lines"></div>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="国家/地区:" prop="currentcountry" class="required">
                            <el-select
                                v-model="taxesInfo.currentcountry"
                                filterable
                                :filter-method="filterCountrys"
                                placeholder="请选择现居地国家"
                                v-on:change="currentcountrySel"
                            >
                                <el-option
                                    v-for="item in countrys"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                >
                                    <span style="float: left">{{ item.subitemname }}</span>
                                    <span
                                        style="
                                            float: right;
                                            color: var(--color-text-accent);
                                            font-size: 12px;
                                        "
                                    >
                                        {{ item.subitem }}
                                    </span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="nonMandatory" :span="12">
                        <el-form-item
                            v-if="isChina"
                            label="省份:"
                            prop="currentprovince"
                            class="required"
                        >
                            <el-select
                                v-model="taxesInfo.currentprovince"
                                filterable
                                placeholder="请选择现居地省份"
                                v-on:change="currentprovinceSel"
                            >
                                <el-option
                                    v-for="item in provinces"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="nonMandatory" :span="12">
                        <el-form-item
                            v-if="isChina"
                            label="城市:"
                            prop="currentcity"
                            class="required"
                        >
                            <el-select
                                v-model="taxesInfo.currentcity"
                                filterable
                                placeholder="请选择现居城市"
                                v-on:change="currentcitySel"
                            >
                                <el-option
                                    v-for="item in currentcity"
                                    :key="item.cityid"
                                    :value="item.cityid"
                                    :label="item.cityname"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="nonMandatory" :span="12">
                        <el-form-item
                            v-if="isChina"
                            label="区/县:"
                            prop="currentcounty"
                            class="required"
                        >
                            <el-select
                                v-model="taxesInfo.currentcounty"
                                filterable
                                placeholder="请选择现居区/县"
                            >
                                <el-option
                                    v-for="item in county"
                                    :key="item.countyid"
                                    :label="item.countyname"
                                    :value="item.countyid"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="nonMandatory" :span="12">
                        <el-form-item label="地址:" prop="currentaddress" class="required">
                            <el-input
                                v-model="taxesInfo.currentaddress"
                                placeholder="请输入现居地地址"
                                :maxlength="32"
                            />
                        </el-form-item>
                    </el-col>
                </el-col>
                <el-col :span="24" class="mes-col">
                    <div class="line-container">
                        <div class="lines"></div>
                        <span class="content">现居地（英文或拼音）</span>
                        <div class="lines"></div>
                    </div>
                    <el-col :span="12">
                        <el-form-item label="国家/地区:" prop="engcurrentcountry" class="required">
                            <el-select
                                v-model="taxesInfo.engcurrentcountry"
                                filterable
                                :filter-method="filterEnCountrys"
                                placeholder="请选择现居地国家（英文或拼音）"
                            >
                                <el-option
                                    v-for="item in enCountrys"
                                    :key="item.subitem"
                                    :label="item.subitem + '(' + item.subitemname + ')'"
                                    :value="item.subitem"
                                >
                                    <span style="float: left">{{ item.subitemname }}</span>
                                    <span
                                        style="
                                            float: right;
                                            color: var(--color-text-accent);
                                            font-size: 12px;
                                        "
                                    >
                                        {{ item.subitem }}
                                    </span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            v-if="taxesInfo.engcurrentcountry == 'CN'"
                            label="省份:"
                            prop="engcurrentprovince"
                            class="required"
                        >
                            <el-input
                                v-model="taxesInfo.engcurrentprovince"
                                placeholder="请输入现居地省份（英文或拼音）"
                                :maxlength="64"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            v-if="taxesInfo.engcurrentcountry == 'CN'"
                            label="城市:"
                            prop="engcurrentcity"
                            class="required"
                        >
                            <el-input
                                v-model="taxesInfo.engcurrentcity"
                                placeholder="请输入现居地城市（英文或拼音）"
                                :maxlength="64"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            v-if="taxesInfo.engcurrentcountry == 'CN'"
                            label="区/县:"
                            prop="engcurrentcounty"
                            class="required"
                        >
                            <el-input v-model="taxesInfo.engcurrentcounty" :maxlength="64" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="地址:" prop="engaddress" class="required">
                            <el-input
                                v-model="taxesInfo.engaddress"
                                placeholder="请输入现居地地址（英文或拼音）"
                                :maxlength="64"
                            />
                        </el-form-item>
                    </el-col>
                </el-col>
                <el-col v-if="nonMandatory" :span="24" class="mes-col">
                    <div class="line-container">
                        <div class="lines"></div>
                        <span class="content">出生地</span>
                        <div class="lines"></div>
                    </div>
                    <el-col :span="12">
                        <el-form-item label="国家/地区:" prop="birthcountry" class="required">
                            <el-select
                                v-model="taxesInfo.birthcountry"
                                filterable
                                :filter-method="filterCountrys"
                                placeholder="请选择出生地国家"
                                v-on:change="
                                    taxesInfo.birthprovince = '';
                                    taxesInfo.birthcity = '';
                                "
                            >
                                <el-option
                                    v-for="item in countrys"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                >
                                    <span style="float: left">{{ item.subitemname }}</span>
                                    <span
                                        style="
                                            float: right;
                                            color: var(--color-text-accent);
                                            font-size: 12px;
                                        "
                                    >
                                        {{ item.subitem }}
                                    </span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            v-if="taxesInfo.birthcountry === 'CN'"
                            label="省份:"
                            prop="birthprovince"
                            class="required"
                        >
                            <el-select
                                v-model="taxesInfo.birthprovince"
                                filterable
                                placeholder="请选择出生地省份"
                                v-on:change="
                                    taxesInfo.birthcity = '';
                                    taxesInfo.birthprovince
                                        ? getCity(taxesInfo.birthprovince, 'birthcity')
                                        : '';
                                "
                            >
                                <el-option
                                    v-for="item in provinces"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            v-if="taxesInfo.birthcountry === 'CN'"
                            label="城市:"
                            prop="birthcity"
                            class="required"
                        >
                            <el-select
                                v-model="taxesInfo.birthcity"
                                filterable
                                placeholder="请选择出生地城市"
                                v-on:change="currentcitySel"
                            >
                                <el-option
                                    v-for="item in birthcity"
                                    :key="item.cityid"
                                    :value="item.cityid"
                                    :label="item.cityname"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            v-if="taxesInfo.birthcountry === 'CN'"
                            label="区/县:"
                            prop="birthcounty"
                            class="required"
                        >
                            <el-select v-model="taxesInfo.birthcounty" filterable>
                                <el-option
                                    v-for="item in birthcounty"
                                    :key="item.countyid"
                                    :label="item.countyname"
                                    :value="item.countyid"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="地址:" prop="birthplace" class="required">
                            <el-input
                                v-model="taxesInfo.birthplace"
                                placeholder="请输入出生地地址"
                                :maxlength="32"
                            />
                        </el-form-item>
                    </el-col>
                </el-col>
                <el-col :span="24" class="mes-col bg">
                    <div class="line-container">
                        <div class="lines"></div>
                        <span class="content">出生地（英文或拼音）</span>
                        <div class="lines"></div>
                    </div>
                    <el-col :span="12">
                        <el-form-item label="国家/地区:" prop="engbirthcountry" class="required">
                            <el-select
                                v-model="taxesInfo.engbirthcountry"
                                filterable
                                :filter-method="filterEnCountrys"
                                placeholder="请选择出生地国家（英文或拼音）"
                            >
                                <el-option
                                    v-for="item in enCountrys"
                                    :key="item.subitem"
                                    :label="item.subitem + '(' + item.subitemname + ')'"
                                    :value="item.subitem"
                                >
                                    <span style="float: left">{{ item.subitemname }}</span>
                                    <span
                                        style="
                                            float: right;
                                            color: var(--color-text-accent);
                                            font-size: 12px;
                                        "
                                    >
                                        {{ item.subitem }}
                                    </span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            v-if="taxesInfo.engbirthcountry == 'CN'"
                            label="省份:"
                            prop="engbirthprovince"
                            class="required"
                        >
                            <el-input
                                v-model="taxesInfo.engbirthprovince"
                                placeholder="请输入出生地省份（英文或拼音）"
                                :maxlength="64"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            v-if="taxesInfo.engbirthcountry == 'CN'"
                            label="城市:"
                            prop="engbirthcity"
                            class="required"
                        >
                            <el-input
                                v-model="taxesInfo.engbirthcity"
                                placeholder="请输入出生地城市（英文或拼音）"
                                :maxlength="64"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            v-if="taxesInfo.engbirthcountry == 'CN'"
                            label="县区:"
                            prop="engbirthcounty"
                            class="required"
                        >
                            <el-input v-model="taxesInfo.engbirthcounty" :maxlength="64" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="地址:" prop="engbirthplace" class="required">
                            <el-input
                                v-model="taxesInfo.engbirthplace"
                                placeholder="请输入出生地地址（英文或拼音）"
                                :maxlength="64"
                            />
                        </el-form-item>
                    </el-col>
                </el-col>
                <el-col :span="24" class="mes-col last">
                    <div class="line-container">
                        <div class="lines"></div>
                        <span class="content">税收居民国(地区)及纳税人识别号</span>
                        <div class="lines"></div>
                    </div>
                    <el-col :span="12">
                        <el-form-item
                            label="税收居民国家/地区:"
                            prop="taxesplace"
                            class="required lh22"
                        >
                            <el-select
                                v-model="taxesInfo.taxesplace"
                                filterable
                                :filter-method="filterSpeCountrys"
                                placeholder="请选择税收居民国家/地区"
                            >
                                <el-option
                                    v-for="item in speCountrys"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                >
                                    <span style="float: left">{{ item.subitemname }}</span>
                                    <span
                                        style="
                                            float: right;
                                            color: var(--color-text-accent);
                                            font-size: 12px;
                                        "
                                    >
                                        {{ item.subitem }}
                                    </span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="有无纳税人识别号:"
                            prop="tHaveTaxID"
                            class="required lh22"
                        >
                            <el-select
                                v-model="taxesInfo.tHaveTaxID"
                                filterable
                                placeholder="请选择有无居民国家/地区纳税人识别号"
                            >
                                <el-option
                                    v-for="item in tHaveTaxIDs"
                                    :key="item.val"
                                    :label="item.text"
                                    :value="item.val"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            v-if="taxesInfo.tHaveTaxID === '1'"
                            label="纳税人识别号:"
                            prop="taxesno"
                            class="required lh22"
                        >
                            <el-input
                                v-model="taxesInfo.taxesno"
                                placeholder="请输入居民国家/地区纳税人识别号"
                                :maxlength="100"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            v-if="taxesInfo.tHaveTaxID === '0'"
                            label="不能提供的原因:"
                            prop="notaxesreason"
                            class="required lh22"
                        >
                            <el-select
                                v-model="taxesInfo.notaxesreason"
                                filterable
                                placeholder="请选择不能提供识别号的原因"
                            >
                                <el-option
                                    v-for="item in notaxesreasons"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            v-if="
                                taxesInfo.tHaveTaxID === '0' &&
                                taxesInfo.notaxesreason == '2' &&
                                taxesInfo.nogetreason !== '0'
                            "
                            label="未能取得的原因:"
                            prop="nogetreason"
                            class="required lh22"
                        >
                            <el-input
                                v-model="taxesInfo.nogetreason"
                                placeholder="请输入未能取得纳税人识别号的原因"
                                :maxlength="128"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="注册国家/地区:" prop="regregioncode" class="lh22">
                            <el-select
                                v-model="taxesInfo.regregioncode"
                                filterable
                                :filter-method="filterCountrys"
                                placeholder="请选择注册国家"
                            >
                                <el-option
                                    v-for="item in countrys"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                >
                                    <span style="float: left">{{ item.subitemname }}</span>
                                    <span
                                        style="
                                            float: right;
                                            color: var(--color-text-accent);
                                            font-size: 12px;
                                        "
                                    >
                                        {{ item.subitem }}
                                    </span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="taxesInfo.regregioncode" :span="12">
                        <el-form-item label="注册地址:" prop="regadress">
                            <el-input
                                v-model="taxesInfo.regadress"
                                placeholder="请输入注册地址"
                                :maxlength="32"
                            />
                        </el-form-item>
                    </el-col>
                </el-col>
            </el-form>
        </el-row>
    </div>
</template>
<script>
export default {
    name: "OpenCrsInfo",
    props: {
        openPar: {
            type: Object,
            default: function () {
                return {};
            }
        }
    },
    data() {
        return {
            taxesInfo: {
                investorsbirthday: "",
                taxestype: "",
                custfamilyname: "",
                custfirstname: "",
                currentcountry: "",
                currentprovince: "",
                currentcity: "",
                currentcounty: "",
                currentaddress: "",
                engcurrentcountry: "",
                engcurrentprovince: "",
                engcurrentcity: "",
                engcurrentcounty: "",
                engaddress: "",
                birthcountry: "",
                birthprovince: "",
                birthcity: "",
                birthplace: "",
                engbirthcountry: "",
                engbirthprovince: "",
                engbirthcity: "",
                engbirthplace: "",
                regregioncode: "",
                regadress: "",
                taxesplace: "",
                tHaveTaxID: "",
                taxesno: "",
                notaxesreason: "",
                nogetreason: ""
            },
            isChina: false, // 是否是居住地在中国
            taxestypes: [],
            speCountrys: [], // 税收居民国家/地区数据字典
            originSpeCountrys: [], // 原始税收居民国家数据，用于搜索过滤
            countrys: [],
            originCountrys: [], // 原始国家数据，用于搜索过滤
            enCountrys: [],
            originEnCountrys: [], // 原始英文国家数据，用于搜索过滤
            provinces: [],
            currentcity: [],
            birthcity: [],
            county: [],
            birthcounty: [],
            notaxesreasons: [],
            tHaveTaxIDs: [
                { val: "0", text: "无" },
                { val: "1", text: "有" }
            ],
            nonMandatory: false,
            rules: {
                custfirstname: [
                    { required: true, message: "请输入姓（英文或拼音）", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                custfamilyname: [
                    { required: true, message: "请输入名（英文或拼音）", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engcurrentprovince: [
                    { required: true, message: "请输入现居省份", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engcurrentcity: [
                    { required: true, message: "请输入现居城市", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engaddress: [
                    { required: true, message: "请输入现居地址", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engbirthprovince: [
                    { required: true, message: "请输入出生省份", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engbirthcity: [
                    { required: true, message: "请输入出生城市", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engbirthcounty: [
                    { required: true, message: "请输入出生地县", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engbirthplace: [
                    { required: true, message: "请输入出生地址", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                currentaddress: [
                    { required: true, message: "请输入现居地地址", trigger: "blur" },
                    { validator: this.validateAddress, trigger: "blur" }
                ],
                nogetreason: [
                    {
                        required: true,
                        message: "请输入未能取得纳税人识别号的原因",
                        trigger: "blur"
                    },
                    { validator: this.$util.validateCCharacter, trigger: "blur" }
                ],
                taxesno: [
                    { required: true, message: "请输入居民国家/地区纳税人识别号", trigger: "blur" },
                    { validator: this.$util.validateCCharacter, trigger: "blur" }
                ],
                currentcountry: [
                    { required: true, message: "请选择现居地国家/地区", trigger: "change" }
                ],
                currentprovince: [
                    { required: true, message: "请选择现居地省份", trigger: "change" }
                ],
                currentcity: [{ required: true, message: "请选择现居地城市", trigger: "change" }],
                currentcounty: [{ required: true, message: "请选择现居地县", trigger: "change" }],
                engcurrentcountry: [
                    { required: true, message: "请选择现居地国家（英文或拼音）", trigger: "change" }
                ],
                birthcountry: [
                    { required: true, message: "请选择出生地国家/地区", trigger: "change" }
                ],
                birthprovince: [{ required: true, message: "请选择出生地省份", trigger: "change" }],
                birthcity: [{ required: true, message: "请选择出生地城市", trigger: "change" }],
                birthplace: [{ required: true, message: "请输入出生地址", trigger: "change" }],
                engbirthcountry: [
                    {
                        required: true,
                        message: "请选择出生地国家/地区（英文或拼音）",
                        trigger: "change"
                    }
                ],
                taxesplace: [
                    { required: true, message: "请选择税收居民国家/地区", trigger: "change" }
                ],
                tHaveTaxID: [
                    {
                        required: true,
                        message: "请选择有无居民国家/地区纳税人识别号",
                        trigger: "change"
                    }
                ],
                notaxesreason: [
                    { required: true, message: "请选择不能提供识别号的原因", trigger: "change" }
                ]
            }
        };
    },
    watch: {
        "taxesInfo.currentcity"(val) {
            if (val !== "") {
                this.getCounty(val);
            }
        },
        "taxesInfo.tHaveTaxID"(val) {
            if (val === "0") {
                this.taxesInfo.taxesno = "";
            } else {
                this.taxesInfo.notaxesreason = "";
                this.taxesInfo.nogetreason = "";
            }
        },
        "taxesInfo.currentcountry"(val) {
            if (val !== "CN") {
                this.isChina = false;
            } else {
                this.isChina = true;
            }
        },
        "taxesInfo.notaxesreason"(val) {
            if (val !== "2") {
                this.taxesInfo.nogetreason = "";
            }
        }
    },
    created() {
        // 初始化数据字典值
        this.taxesInfo.investorsbirthday = this.openPar.birthdate;
        this.taxestypes = this.$cache.getDict("120043");
        this.taxestypes = this.taxestypes.filter((item) => item.subitem !== "3");
        const _countryData = this.$cache.getDict("120109");
        this.countrys = this.$util.sortCountryWithChinaFirst(_countryData);
        // 保存原始数据用于搜索
        this.originCountrys = [...this.countrys];
        this.speCountrys = this.countrys.filter((item) => {
            return item.subitem !== "CN";
        });
        // 保存原始税收居民国家数据用于搜索
        this.originSpeCountrys = [...this.speCountrys];
        this.enCountrys = this.$cache.getDict("120109");
        // 按国家码 subitem 排序
        this.enCountrys.sort((a, b) => {
            if (a.subitem < b.subitem) return -1;
            if (a.subitem > b.subitem) return 1;
            return 0;
        });
        // 保存原始英文国家数据用于搜索
        this.originEnCountrys = [...this.enCountrys];
        this.provinces = this.$cache.getDict("190021");
        this.notaxesreasons = this.$cache.getDict("120044");
    },
    methods: {
        // 根据国家名称和国家码搜索过滤（中文）
        filterCountrys(query) {
            if (query) {
                this.countrys = this.originCountrys.filter((item) => {
                    const name = item.subitemname && item.subitemname.toLowerCase();
                    const code = item.subitem && item.subitem.toLowerCase();
                    const searchQuery = query.toLowerCase();
                    return name && name.includes(searchQuery) || code && code.includes(searchQuery);
                });
            } else {
                this.countrys = [...this.originCountrys];
            }
        },
        // 根据国家名称和国家码搜索过滤（英文）
        filterEnCountrys(query) {
            if (query) {
                this.enCountrys = this.originEnCountrys.filter((item) => {
                    const name = item.subitemname && item.subitemname.toLowerCase();
                    const code = item.subitem && item.subitem.toLowerCase();
                    const searchQuery = query.toLowerCase();
                    return name && name.includes(searchQuery) || code && code.includes(searchQuery);
                });
            } else {
                this.enCountrys = [...this.originEnCountrys];
            }
        },
        // 根据国家名称和国家码搜索过滤（税收居民国）
        filterSpeCountrys(query) {
            if (query) {
                this.speCountrys = this.originSpeCountrys.filter((item) => {
                    const name = item.subitemname && item.subitemname.toLowerCase();
                    const code = item.subitem && item.subitem.toLowerCase();
                    const searchQuery = query.toLowerCase();
                    return name && name.includes(searchQuery) || code && code.includes(searchQuery);
                });
            } else {
                this.speCountrys = [...this.originSpeCountrys];
            }
        },
        validateAddress(rule, value, callback) {
            if (this.isChina || value.trim() !== "") {
                this.$util.validateCCharacter(rule, value, callback);
            } else {
                callback();
            }
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo(formName = "taxesInfo") {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    const crsinfo = {
                        ...this.taxesInfo,
                        engbirthaddress: this.taxesInfo.engbirthplace,
                        engcurrentaddress: this.taxesInfo.engaddress,
                        birthcountry: this.taxesInfo.engbirthcountry,
                        controlbirthday: this.openPar.birthdate,
                        acctCustCrsTaxVoList: JSON.stringify([
                            {
                                regregioncode: this.taxesInfo.regregioncode,
                                regadress: this.taxesInfo.regadress,
                                taxesplace: this.taxesInfo.taxesplace,
                                taxesno: this.taxesInfo.taxesno,
                                notaxesreason: this.taxesInfo.notaxesreason,
                                nogetreason: this.taxesInfo.nogetreason
                            }
                        ])
                    };
                    this.$emit("get-acct-crs", crsinfo);
                } else {
                    this.$errorScroll();
                }
            });
        },
        async getCity(val, citykey) {
            let cityList = this.$cache.get("address")["citylists"][val] || [];
            this[citykey] = cityList;
        },
        getCounty(val) {
            let countyList = this.$cache.get("address")["countylists"][val] || [];
            this.county = countyList;
        },
        currentcountrySel() {
            this.taxesInfo.currentprovince = "";
            this.taxesInfo.currentcity = "";
            this.taxesInfo.currentcounty = "";
        },
        currentprovinceSel() {
            this.taxesInfo.currentcity = "";
            this.taxesInfo.currentcounty = "";
            if (!this.taxesInfo.currentprovince) return;
            this.getCity(this.taxesInfo.currentprovince, "currentcity");
        },
        currentcitySel(val) {
            let countyList = this.$cache.get("address")["countylists"][val] || [];
            this.birthcounty = countyList;
        }
    }
};
</script>
<style lang="scss" scoped>
.comp-open-acct-crs-info {
    margin-top: 28px;
    ::v-deep .el-form-item {
        label.el-form-item__label {
            font-size: 14px;
            color: #333;
            margin-right: 8px;
            min-height: 40px;
            line-height: 40px;
            &:before {
                display: inline;
            }
        }
        .el-input {
            font-size: $f16;
        }
        .el-input--small .el-input__inner {
            height: 40px;
            line-height: 40px;
        }
    }
    ::v-deep .lh22 label.el-form-item__label {
        line-height: 22px;
    }
    .col-input-w100 {
        ::v-deep .el-input {
            width: 100%;
        }
    }
    .comp-divide-title {
        margin-bottom: 20px;
    }
}
.line-container {
    display: flex;
    align-items: center;
    position: relative;
    color: #9a9a9a;
    font-size: 16px;
    margin: 20px 0;
    .lines {
        // flex-grow: 1;
        height: 1px;
        background-color: #eaeaea;
        flex: 1;
        /* 设置横线的间距 */
    }
    .content {
        margin: 0 10px;
        white-space: nowrap;
        /* 防止文字换行 */
    }
}
</style>
